module.exports = __webpack_public_path__ + "src/components/Booking/Verification/envelope.png?95104e58";


//////////////////
// WEBPACK FOOTER
// ./src/components/Booking/Verification/envelope.png
// module id = 3080
// module chunks = 8